import React, { useState } from "react";
import Popup from "../popup/Popup";
import { POPUP_FORM_CONTENT_CLASS, ACTION_POPUP_CONTENT_INNER_CLASS } from "../popup/popupLayoutSpec";
import {
  AccountPopupCheckboxGroup,
  AccountPopupSaveFooter,
} from "./accountPopupFields";

const AcceptedPaymentsPopup = ({ isOpen, onClose, setFieldValue, values, initialStep = 0 }) => {
  const [currentStep] = useState(initialStep);

  const displayValues = {
    paymentMethods: values.paymentMethods || [],
  };

  const paymentMethods = [
    { label: "Card", value: "card" },
    { label: "Apple Pay", value: "apple_pay" },
    { label: "Google Pay", value: "google_pay" },
    { label: "Afterpay", value: "afterpay" },
    { label: "Zip", value: "zip" },
    { label: "Klarna", value: "klarna" },
    { label: "PayID", value: "payid" },
    { label: "Bank Transfer", value: "bank_transfer" },
    { label: "Cash", value: "cash" },
  ];

  const handleCheckboxChange = (value, checked) => {
    const current = displayValues.paymentMethods || [];
    if (checked) {
      setFieldValue("paymentMethods", [...current, value]);
    } else {
      setFieldValue(
        "paymentMethods",
        current.filter((item) => item !== value)
      );
    }
  };

  if (!isOpen) return null;

  return (
    <Popup
      setTrigger={() => {}}
      ShowCrossButton={true}
      cross={true}
      onClose={onClose}
      businessDashboard={true}
      hideLogoInHeader={true}
    >
      <div
        className="overflow-auto relative flex items-center justify-center"
        style={{ minHeight: "calc(100vh - 120px)" }}
      >
        <div className={POPUP_FORM_CONTENT_CLASS}>
          <div className={ACTION_POPUP_CONTENT_INNER_CLASS}>
            <AccountPopupCheckboxGroup
              title="Payment Methods"
              tooltip="Select the payment methods you accept from customers"
              description="Select all methods you accept."
              options={paymentMethods}
              selectedValues={displayValues.paymentMethods}
              onToggle={handleCheckboxChange}
            />
            <AccountPopupSaveFooter onClick={onClose} />
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default AcceptedPaymentsPopup;
